// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as PortalRouteImport } from './routes/_portal'
import { Route as PreviewRouteImport } from './routes/_preview'
import { Route as AgentIndexRouteImport } from './routes/agent.index'
import { Route as LoginIndexRouteImport } from './routes/login.index'
import { Route as OnboardingIndexRouteImport } from './routes/onboarding.index'
import { Route as PrivacyIndexRouteImport } from './routes/privacy.index'
import { Route as SecurityIndexRouteImport } from './routes/security.index'
import { Route as SubscribeIndexRouteImport } from './routes/subscribe.index'
import { Route as SubscriptionEndedIndexRouteImport } from './routes/subscription-ended.index'
import { Route as SupportIndexRouteImport } from './routes/support.index'
import { Route as TermsIndexRouteImport } from './routes/terms.index'
import { Route as PortalAdminIndexRouteImport } from './routes/_portal.admin.index'
import { Route as PortalAdvancedAgentIndexRouteImport } from './routes/_portal.advanced-agent.index'
import { Route as PortalAiInfrastructureBacklogIndexRouteImport } from './routes/_portal.ai-infrastructure-backlog.index'
import { Route as PortalCtoStudyIndexRouteImport } from './routes/_portal.cto-study.index'
import { Route as PortalDataCenterDiligenceIndexRouteImport } from './routes/_portal.data-center-diligence.index'
import { Route as PortalFinancialDashboardIndexRouteImport } from './routes/_portal.financial-dashboard.index'
import { Route as PortalFinancialScorecardIndexRouteImport } from './routes/_portal.financial-scorecard.index'
import { Route as PortalLegacyModelsIndexRouteImport } from './routes/_portal.legacy-models.index'
import { Route as PortalPcMarketTamIndexRouteImport } from './routes/_portal.pc-market-tam.index'
import { Route as PortalSiliconSystemsEraIndexRouteImport } from './routes/_portal.silicon-systems-era.index'
import { Route as PortalTokenomicsModelIndexRouteImport } from './routes/_portal.tokenomics-model.index'
import { Route as PreviewCapacityRiskTransferIndexRouteImport } from './routes/_preview.capacity-risk-transfer.index'
import { Route as PreviewDashboardIndexRouteImport } from './routes/_preview.dashboard.index'
import { Route as PreviewModelsIndexRouteImport } from './routes/_preview.models.index'
import { Route as PreviewNotesIndexRouteImport } from './routes/_preview.notes.index'
import { Route as PreviewVideosIndexRouteImport } from './routes/_preview.videos.index'
import { Route as SubscribeSuccessIndexRouteImport } from './routes/subscribe.success.index'
import { Route as PortalAdminAgentEvalIndexRouteImport } from './routes/_portal.admin.agent-eval.index'
import { Route as PortalAdminAgentSettingsIndexRouteImport } from './routes/_portal.admin.agent-settings.index'
import { Route as PortalAdminAgentIndexRouteImport } from './routes/_portal.admin.agent.index'
import { Route as PortalAdminAiOperationsIndexRouteImport } from './routes/_portal.admin.ai-operations.index'
import { Route as PortalAdminApiKeysIndexRouteImport } from './routes/_portal.admin.api-keys.index'
import { Route as PortalAdminBillingIndexRouteImport } from './routes/_portal.admin.billing.index'
import { Route as PortalAdminCapacityRiskTransferIndexRouteImport } from './routes/_portal.admin.capacity-risk-transfer.index'
import { Route as PortalAdminFinancialDashboardIndexRouteImport } from './routes/_portal.admin.financial-dashboard.index'
import { Route as PortalAdminKnowledgeBaseIndexRouteImport } from './routes/_portal.admin.knowledge-base.index'
import { Route as PortalAdminLegacyModelsIndexRouteImport } from './routes/_portal.admin.legacy-models.index'
import { Route as PortalAdminLogsIndexRouteImport } from './routes/_portal.admin.logs.index'
import { Route as PortalAdminMcpIndexRouteImport } from './routes/_portal.admin.mcp.index'
import { Route as PortalAdminModelsIndexRouteImport } from './routes/_portal.admin.models.index'
import { Route as PortalAdminNotesIndexRouteImport } from './routes/_portal.admin.notes.index'
import { Route as PortalAdminOperationsIndexRouteImport } from './routes/_portal.admin.operations.index'
import { Route as PortalAdminPagesIndexRouteImport } from './routes/_portal.admin.pages.index'
import { Route as PortalAdminScorecardIndexRouteImport } from './routes/_portal.admin.scorecard.index'
import { Route as PortalAdminStatsIndexRouteImport } from './routes/_portal.admin.stats.index'
import { Route as PortalAdminSubstackSyncIndexRouteImport } from './routes/_portal.admin.substack-sync.index'
import { Route as PortalAdminSupportIndexRouteImport } from './routes/_portal.admin.support.index'
import { Route as PortalAdminUsersIndexRouteImport } from './routes/_portal.admin.users.index'
import { Route as PortalAdminVideosIndexRouteImport } from './routes/_portal.admin.videos.index'
import { Route as PortalDashboardBillingIndexRouteImport } from './routes/_portal.dashboard.billing.index'
import { Route as PortalDashboardSupportIndexRouteImport } from './routes/_portal.dashboard.support.index'
import { Route as PortalDevLogsIndexRouteImport } from './routes/_portal.dev.logs.index'
import { Route as PortalDevStatsIndexRouteImport } from './routes/_portal.dev.stats.index'
import { Route as PortalFinancialDashboardTickerIndexRouteImport } from './routes/_portal.financial-dashboard.$ticker.index'
import { Route as PortalFinancialScorecardTickerIndexRouteImport } from './routes/_portal.financial-scorecard.$ticker.index'
import { Route as PortalLegacyModelsSlugIndexRouteImport } from './routes/_portal.legacy-models.$slug.index'
import { Route as PreviewModelsSlugIndexRouteImport } from './routes/_preview.models.$slug.index'
import { Route as PreviewNotesSlugIndexRouteImport } from './routes/_preview.notes.$slug.index'
import { Route as PreviewVideosVideoIdIndexRouteImport } from './routes/_preview.videos.$videoId.index'
import { Route as AgentShareShareIdIndexRouteImport } from './routes/agent.share.$shareId.index'
import { Route as ChatsShareShareIdIndexRouteImport } from './routes/chats.share.$shareId.index'
import { Route as EmbedVideosVideoIdIndexRouteImport } from './routes/embed.videos.$videoId.index'
import { Route as NotesSlugPdfIndexRouteImport } from './routes/notes.$slug.pdf.index'
import { Route as PortalAdminModelsModelIdIndexRouteImport } from './routes/_portal.admin.models.$modelId.index'
import { Route as PreviewNotesCompanySlugIndexRouteImport } from './routes/_preview.notes.company.$slug.index'
import { Route as PreviewNotesModelSlugIndexRouteImport } from './routes/_preview.notes.model.$slug.index'
import { Route as PreviewNotesThemeSlugIndexRouteImport } from './routes/_preview.notes.theme.$slug.index'
import { Route as PreviewNotesTypeTypeIndexRouteImport } from './routes/_preview.notes.type.$type.index'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const PortalRoute = PortalRouteImport.update({
            id: '/_portal',getParentRoute: () => rootRouteImport
          })
const PreviewRoute = PreviewRouteImport.update({
            id: '/_preview',getParentRoute: () => rootRouteImport
          })
const AgentIndexRoute = AgentIndexRouteImport.update({
            id: '/agent/',path: '/agent/',getParentRoute: () => rootRouteImport
          })
const LoginIndexRoute = LoginIndexRouteImport.update({
            id: '/login/',path: '/login/',getParentRoute: () => rootRouteImport
          })
const OnboardingIndexRoute = OnboardingIndexRouteImport.update({
            id: '/onboarding/',path: '/onboarding/',getParentRoute: () => rootRouteImport
          })
const PrivacyIndexRoute = PrivacyIndexRouteImport.update({
            id: '/privacy/',path: '/privacy/',getParentRoute: () => rootRouteImport
          })
const SecurityIndexRoute = SecurityIndexRouteImport.update({
            id: '/security/',path: '/security/',getParentRoute: () => rootRouteImport
          })
const SubscribeIndexRoute = SubscribeIndexRouteImport.update({
            id: '/subscribe/',path: '/subscribe/',getParentRoute: () => rootRouteImport
          })
const SubscriptionEndedIndexRoute = SubscriptionEndedIndexRouteImport.update({
            id: '/subscription-ended/',path: '/subscription-ended/',getParentRoute: () => rootRouteImport
          })
const SupportIndexRoute = SupportIndexRouteImport.update({
            id: '/support/',path: '/support/',getParentRoute: () => rootRouteImport
          })
const TermsIndexRoute = TermsIndexRouteImport.update({
            id: '/terms/',path: '/terms/',getParentRoute: () => rootRouteImport
          })
const PortalAdminIndexRoute = PortalAdminIndexRouteImport.update({
            id: '/admin/',path: '/admin/',getParentRoute: () => PortalRoute
          })
const PortalAdvancedAgentIndexRoute = PortalAdvancedAgentIndexRouteImport.update({
            id: '/advanced-agent/',path: '/advanced-agent/',getParentRoute: () => PortalRoute
          })
const PortalAiInfrastructureBacklogIndexRoute = PortalAiInfrastructureBacklogIndexRouteImport.update({
            id: '/ai-infrastructure-backlog/',path: '/ai-infrastructure-backlog/',getParentRoute: () => PortalRoute
          })
const PortalCtoStudyIndexRoute = PortalCtoStudyIndexRouteImport.update({
            id: '/cto-study/',path: '/cto-study/',getParentRoute: () => PortalRoute
          })
const PortalDataCenterDiligenceIndexRoute = PortalDataCenterDiligenceIndexRouteImport.update({
            id: '/data-center-diligence/',path: '/data-center-diligence/',getParentRoute: () => PortalRoute
          })
const PortalFinancialDashboardIndexRoute = PortalFinancialDashboardIndexRouteImport.update({
            id: '/financial-dashboard/',path: '/financial-dashboard/',getParentRoute: () => PortalRoute
          })
const PortalFinancialScorecardIndexRoute = PortalFinancialScorecardIndexRouteImport.update({
            id: '/financial-scorecard/',path: '/financial-scorecard/',getParentRoute: () => PortalRoute
          })
const PortalLegacyModelsIndexRoute = PortalLegacyModelsIndexRouteImport.update({
            id: '/legacy-models/',path: '/legacy-models/',getParentRoute: () => PortalRoute
          })
const PortalPcMarketTamIndexRoute = PortalPcMarketTamIndexRouteImport.update({
            id: '/pc-market-tam/',path: '/pc-market-tam/',getParentRoute: () => PortalRoute
          })
const PortalSiliconSystemsEraIndexRoute = PortalSiliconSystemsEraIndexRouteImport.update({
            id: '/silicon-systems-era/',path: '/silicon-systems-era/',getParentRoute: () => PortalRoute
          })
const PortalTokenomicsModelIndexRoute = PortalTokenomicsModelIndexRouteImport.update({
            id: '/tokenomics-model/',path: '/tokenomics-model/',getParentRoute: () => PortalRoute
          })
const PreviewCapacityRiskTransferIndexRoute = PreviewCapacityRiskTransferIndexRouteImport.update({
            id: '/capacity-risk-transfer/',path: '/capacity-risk-transfer/',getParentRoute: () => PreviewRoute
          })
const PreviewDashboardIndexRoute = PreviewDashboardIndexRouteImport.update({
            id: '/dashboard/',path: '/dashboard/',getParentRoute: () => PreviewRoute
          })
const PreviewModelsIndexRoute = PreviewModelsIndexRouteImport.update({
            id: '/models/',path: '/models/',getParentRoute: () => PreviewRoute
          })
const PreviewNotesIndexRoute = PreviewNotesIndexRouteImport.update({
            id: '/notes/',path: '/notes/',getParentRoute: () => PreviewRoute
          })
const PreviewVideosIndexRoute = PreviewVideosIndexRouteImport.update({
            id: '/videos/',path: '/videos/',getParentRoute: () => PreviewRoute
          })
const SubscribeSuccessIndexRoute = SubscribeSuccessIndexRouteImport.update({
            id: '/subscribe/success/',path: '/subscribe/success/',getParentRoute: () => rootRouteImport
          })
const PortalAdminAgentEvalIndexRoute = PortalAdminAgentEvalIndexRouteImport.update({
            id: '/admin/agent-eval/',path: '/admin/agent-eval/',getParentRoute: () => PortalRoute
          })
const PortalAdminAgentSettingsIndexRoute = PortalAdminAgentSettingsIndexRouteImport.update({
            id: '/admin/agent-settings/',path: '/admin/agent-settings/',getParentRoute: () => PortalRoute
          })
const PortalAdminAgentIndexRoute = PortalAdminAgentIndexRouteImport.update({
            id: '/admin/agent/',path: '/admin/agent/',getParentRoute: () => PortalRoute
          })
const PortalAdminAiOperationsIndexRoute = PortalAdminAiOperationsIndexRouteImport.update({
            id: '/admin/ai-operations/',path: '/admin/ai-operations/',getParentRoute: () => PortalRoute
          })
const PortalAdminApiKeysIndexRoute = PortalAdminApiKeysIndexRouteImport.update({
            id: '/admin/api-keys/',path: '/admin/api-keys/',getParentRoute: () => PortalRoute
          })
const PortalAdminBillingIndexRoute = PortalAdminBillingIndexRouteImport.update({
            id: '/admin/billing/',path: '/admin/billing/',getParentRoute: () => PortalRoute
          })
const PortalAdminCapacityRiskTransferIndexRoute = PortalAdminCapacityRiskTransferIndexRouteImport.update({
            id: '/admin/capacity-risk-transfer/',path: '/admin/capacity-risk-transfer/',getParentRoute: () => PortalRoute
          })
const PortalAdminFinancialDashboardIndexRoute = PortalAdminFinancialDashboardIndexRouteImport.update({
            id: '/admin/financial-dashboard/',path: '/admin/financial-dashboard/',getParentRoute: () => PortalRoute
          })
const PortalAdminKnowledgeBaseIndexRoute = PortalAdminKnowledgeBaseIndexRouteImport.update({
            id: '/admin/knowledge-base/',path: '/admin/knowledge-base/',getParentRoute: () => PortalRoute
          })
const PortalAdminLegacyModelsIndexRoute = PortalAdminLegacyModelsIndexRouteImport.update({
            id: '/admin/legacy-models/',path: '/admin/legacy-models/',getParentRoute: () => PortalRoute
          })
const PortalAdminLogsIndexRoute = PortalAdminLogsIndexRouteImport.update({
            id: '/admin/logs/',path: '/admin/logs/',getParentRoute: () => PortalRoute
          })
const PortalAdminMcpIndexRoute = PortalAdminMcpIndexRouteImport.update({
            id: '/admin/mcp/',path: '/admin/mcp/',getParentRoute: () => PortalRoute
          })
const PortalAdminModelsIndexRoute = PortalAdminModelsIndexRouteImport.update({
            id: '/admin/models/',path: '/admin/models/',getParentRoute: () => PortalRoute
          })
const PortalAdminNotesIndexRoute = PortalAdminNotesIndexRouteImport.update({
            id: '/admin/notes/',path: '/admin/notes/',getParentRoute: () => PortalRoute
          })
const PortalAdminOperationsIndexRoute = PortalAdminOperationsIndexRouteImport.update({
            id: '/admin/operations/',path: '/admin/operations/',getParentRoute: () => PortalRoute
          })
const PortalAdminPagesIndexRoute = PortalAdminPagesIndexRouteImport.update({
            id: '/admin/pages/',path: '/admin/pages/',getParentRoute: () => PortalRoute
          })
const PortalAdminScorecardIndexRoute = PortalAdminScorecardIndexRouteImport.update({
            id: '/admin/scorecard/',path: '/admin/scorecard/',getParentRoute: () => PortalRoute
          })
const PortalAdminStatsIndexRoute = PortalAdminStatsIndexRouteImport.update({
            id: '/admin/stats/',path: '/admin/stats/',getParentRoute: () => PortalRoute
          })
const PortalAdminSubstackSyncIndexRoute = PortalAdminSubstackSyncIndexRouteImport.update({
            id: '/admin/substack-sync/',path: '/admin/substack-sync/',getParentRoute: () => PortalRoute
          })
const PortalAdminSupportIndexRoute = PortalAdminSupportIndexRouteImport.update({
            id: '/admin/support/',path: '/admin/support/',getParentRoute: () => PortalRoute
          })
const PortalAdminUsersIndexRoute = PortalAdminUsersIndexRouteImport.update({
            id: '/admin/users/',path: '/admin/users/',getParentRoute: () => PortalRoute
          })
const PortalAdminVideosIndexRoute = PortalAdminVideosIndexRouteImport.update({
            id: '/admin/videos/',path: '/admin/videos/',getParentRoute: () => PortalRoute
          })
const PortalDashboardBillingIndexRoute = PortalDashboardBillingIndexRouteImport.update({
            id: '/dashboard/billing/',path: '/dashboard/billing/',getParentRoute: () => PortalRoute
          })
const PortalDashboardSupportIndexRoute = PortalDashboardSupportIndexRouteImport.update({
            id: '/dashboard/support/',path: '/dashboard/support/',getParentRoute: () => PortalRoute
          })
const PortalDevLogsIndexRoute = PortalDevLogsIndexRouteImport.update({
            id: '/dev/logs/',path: '/dev/logs/',getParentRoute: () => PortalRoute
          })
const PortalDevStatsIndexRoute = PortalDevStatsIndexRouteImport.update({
            id: '/dev/stats/',path: '/dev/stats/',getParentRoute: () => PortalRoute
          })
const PortalFinancialDashboardTickerIndexRoute = PortalFinancialDashboardTickerIndexRouteImport.update({
            id: '/financial-dashboard/$ticker/',path: '/financial-dashboard/$ticker/',getParentRoute: () => PortalRoute
          })
const PortalFinancialScorecardTickerIndexRoute = PortalFinancialScorecardTickerIndexRouteImport.update({
            id: '/financial-scorecard/$ticker/',path: '/financial-scorecard/$ticker/',getParentRoute: () => PortalRoute
          })
const PortalLegacyModelsSlugIndexRoute = PortalLegacyModelsSlugIndexRouteImport.update({
            id: '/legacy-models/$slug/',path: '/legacy-models/$slug/',getParentRoute: () => PortalRoute
          })
const PreviewModelsSlugIndexRoute = PreviewModelsSlugIndexRouteImport.update({
            id: '/models/$slug/',path: '/models/$slug/',getParentRoute: () => PreviewRoute
          })
const PreviewNotesSlugIndexRoute = PreviewNotesSlugIndexRouteImport.update({
            id: '/notes/$slug/',path: '/notes/$slug/',getParentRoute: () => PreviewRoute
          })
const PreviewVideosVideoIdIndexRoute = PreviewVideosVideoIdIndexRouteImport.update({
            id: '/videos/$videoId/',path: '/videos/$videoId/',getParentRoute: () => PreviewRoute
          })
const AgentShareShareIdIndexRoute = AgentShareShareIdIndexRouteImport.update({
            id: '/agent/share/$shareId/',path: '/agent/share/$shareId/',getParentRoute: () => rootRouteImport
          })
const ChatsShareShareIdIndexRoute = ChatsShareShareIdIndexRouteImport.update({
            id: '/chats/share/$shareId/',path: '/chats/share/$shareId/',getParentRoute: () => rootRouteImport
          })
const EmbedVideosVideoIdIndexRoute = EmbedVideosVideoIdIndexRouteImport.update({
            id: '/embed/videos/$videoId/',path: '/embed/videos/$videoId/',getParentRoute: () => rootRouteImport
          })
const NotesSlugPdfIndexRoute = NotesSlugPdfIndexRouteImport.update({
            id: '/notes/$slug/pdf/',path: '/notes/$slug/pdf/',getParentRoute: () => rootRouteImport
          })
const PortalAdminModelsModelIdIndexRoute = PortalAdminModelsModelIdIndexRouteImport.update({
            id: '/admin/models/$modelId/',path: '/admin/models/$modelId/',getParentRoute: () => PortalRoute
          })
const PreviewNotesCompanySlugIndexRoute = PreviewNotesCompanySlugIndexRouteImport.update({
            id: '/notes/company/$slug/',path: '/notes/company/$slug/',getParentRoute: () => PreviewRoute
          })
const PreviewNotesModelSlugIndexRoute = PreviewNotesModelSlugIndexRouteImport.update({
            id: '/notes/model/$slug/',path: '/notes/model/$slug/',getParentRoute: () => PreviewRoute
          })
const PreviewNotesThemeSlugIndexRoute = PreviewNotesThemeSlugIndexRouteImport.update({
            id: '/notes/theme/$slug/',path: '/notes/theme/$slug/',getParentRoute: () => PreviewRoute
          })
const PreviewNotesTypeTypeIndexRoute = PreviewNotesTypeTypeIndexRouteImport.update({
            id: '/notes/type/$type/',path: '/notes/type/$type/',getParentRoute: () => PreviewRoute
          })





const PortalRouteChildren = {
  PortalAdminIndexRoute: PortalAdminIndexRoute,PortalAdvancedAgentIndexRoute: PortalAdvancedAgentIndexRoute,PortalAiInfrastructureBacklogIndexRoute: PortalAiInfrastructureBacklogIndexRoute,PortalCtoStudyIndexRoute: PortalCtoStudyIndexRoute,PortalDataCenterDiligenceIndexRoute: PortalDataCenterDiligenceIndexRoute,PortalFinancialDashboardIndexRoute: PortalFinancialDashboardIndexRoute,PortalFinancialScorecardIndexRoute: PortalFinancialScorecardIndexRoute,PortalLegacyModelsIndexRoute: PortalLegacyModelsIndexRoute,PortalPcMarketTamIndexRoute: PortalPcMarketTamIndexRoute,PortalSiliconSystemsEraIndexRoute: PortalSiliconSystemsEraIndexRoute,PortalTokenomicsModelIndexRoute: PortalTokenomicsModelIndexRoute,PortalAdminAgentEvalIndexRoute: PortalAdminAgentEvalIndexRoute,PortalAdminAgentSettingsIndexRoute: PortalAdminAgentSettingsIndexRoute,PortalAdminAgentIndexRoute: PortalAdminAgentIndexRoute,PortalAdminAiOperationsIndexRoute: PortalAdminAiOperationsIndexRoute,PortalAdminApiKeysIndexRoute: PortalAdminApiKeysIndexRoute,PortalAdminBillingIndexRoute: PortalAdminBillingIndexRoute,PortalAdminCapacityRiskTransferIndexRoute: PortalAdminCapacityRiskTransferIndexRoute,PortalAdminFinancialDashboardIndexRoute: PortalAdminFinancialDashboardIndexRoute,PortalAdminKnowledgeBaseIndexRoute: PortalAdminKnowledgeBaseIndexRoute,PortalAdminLegacyModelsIndexRoute: PortalAdminLegacyModelsIndexRoute,PortalAdminLogsIndexRoute: PortalAdminLogsIndexRoute,PortalAdminMcpIndexRoute: PortalAdminMcpIndexRoute,PortalAdminModelsIndexRoute: PortalAdminModelsIndexRoute,PortalAdminNotesIndexRoute: PortalAdminNotesIndexRoute,PortalAdminOperationsIndexRoute: PortalAdminOperationsIndexRoute,PortalAdminPagesIndexRoute: PortalAdminPagesIndexRoute,PortalAdminScorecardIndexRoute: PortalAdminScorecardIndexRoute,PortalAdminStatsIndexRoute: PortalAdminStatsIndexRoute,PortalAdminSubstackSyncIndexRoute: PortalAdminSubstackSyncIndexRoute,PortalAdminSupportIndexRoute: PortalAdminSupportIndexRoute,PortalAdminUsersIndexRoute: PortalAdminUsersIndexRoute,PortalAdminVideosIndexRoute: PortalAdminVideosIndexRoute,PortalDashboardBillingIndexRoute: PortalDashboardBillingIndexRoute,PortalDashboardSupportIndexRoute: PortalDashboardSupportIndexRoute,PortalDevLogsIndexRoute: PortalDevLogsIndexRoute,PortalDevStatsIndexRoute: PortalDevStatsIndexRoute,PortalFinancialDashboardTickerIndexRoute: PortalFinancialDashboardTickerIndexRoute,PortalFinancialScorecardTickerIndexRoute: PortalFinancialScorecardTickerIndexRoute,PortalLegacyModelsSlugIndexRoute: PortalLegacyModelsSlugIndexRoute,PortalAdminModelsModelIdIndexRoute: PortalAdminModelsModelIdIndexRoute
}

const PortalRouteWithChildren = PortalRoute._addFileChildren(PortalRouteChildren)




const PreviewRouteChildren = {
  PreviewCapacityRiskTransferIndexRoute: PreviewCapacityRiskTransferIndexRoute,PreviewDashboardIndexRoute: PreviewDashboardIndexRoute,PreviewModelsIndexRoute: PreviewModelsIndexRoute,PreviewNotesIndexRoute: PreviewNotesIndexRoute,PreviewVideosIndexRoute: PreviewVideosIndexRoute,PreviewModelsSlugIndexRoute: PreviewModelsSlugIndexRoute,PreviewNotesSlugIndexRoute: PreviewNotesSlugIndexRoute,PreviewVideosVideoIdIndexRoute: PreviewVideosVideoIdIndexRoute,PreviewNotesCompanySlugIndexRoute: PreviewNotesCompanySlugIndexRoute,PreviewNotesModelSlugIndexRoute: PreviewNotesModelSlugIndexRoute,PreviewNotesThemeSlugIndexRoute: PreviewNotesThemeSlugIndexRoute,PreviewNotesTypeTypeIndexRoute: PreviewNotesTypeTypeIndexRoute
}

const PreviewRouteWithChildren = PreviewRoute._addFileChildren(PreviewRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,PortalRoute: PortalRouteWithChildren,PreviewRoute: PreviewRouteWithChildren,AgentIndexRoute: AgentIndexRoute,LoginIndexRoute: LoginIndexRoute,OnboardingIndexRoute: OnboardingIndexRoute,PrivacyIndexRoute: PrivacyIndexRoute,SecurityIndexRoute: SecurityIndexRoute,SubscribeIndexRoute: SubscribeIndexRoute,SubscriptionEndedIndexRoute: SubscriptionEndedIndexRoute,SupportIndexRoute: SupportIndexRoute,TermsIndexRoute: TermsIndexRoute,SubscribeSuccessIndexRoute: SubscribeSuccessIndexRoute,AgentShareShareIdIndexRoute: AgentShareShareIdIndexRoute,ChatsShareShareIdIndexRoute: ChatsShareShareIdIndexRoute,EmbedVideosVideoIdIndexRoute: EmbedVideosVideoIdIndexRoute,NotesSlugPdfIndexRoute: NotesSlugPdfIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)